import ApproveBranch from './approve-branch-modal';

export default ApproveBranch;
